"use strict";
/**
 * Created by fan on 3/23/17.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var navs;
        (function (navs) {
            var reportOptions;
            (function (reportOptions) {
                var errors;
                (function (errors) {
                    var EntryNoNameError = /** @class */ (function (_super) {
                        __extends(EntryNoNameError, _super);
                        function EntryNoNameError() {
                            return _super.call(this, "Entry must have a name") || this;
                        }
                        return EntryNoNameError;
                    }(Error));
                    errors.EntryNoNameError = EntryNoNameError;
                    var TagNoNameError = /** @class */ (function (_super) {
                        __extends(TagNoNameError, _super);
                        function TagNoNameError() {
                            return _super.call(this, "Tag must have a name") || this;
                        }
                        return TagNoNameError;
                    }(Error));
                    errors.TagNoNameError = TagNoNameError;
                })(errors = reportOptions.errors || (reportOptions.errors = {}));
            })(reportOptions = navs.reportOptions || (navs.reportOptions = {}));
        })(navs = r6.navs || (r6.navs = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.navs.reportOptions.errors;
//# sourceMappingURL=report-option-errors.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options/app/js/logic/report-option-errors.js